import { CORE_ROUTE } from "@obg/ngx.core";

export const ASSESSMENTS_REDIRECT_ROUTES: string[] = [
	CORE_ROUTE.lobbies.casino,
	CORE_ROUTE.lobbies.livecasino,
	CORE_ROUTE.lobbies.virtualSports,
];
